module.exports = __webpack_public_path__ + "img/hero-bg.8b7b1e51.webp";